import { IGatsbyImageData } from "gatsby-plugin-image/dist/src/components/gatsby-image.browser";
import { IGatsbyImageDataParent } from "gatsby-plugin-image/dist/src/components/hooks";

export interface BlockType {
    id: string;
    blockId: string;
    title: string;
    parentPage?: string;
    attributes: FieldType[];
    salesChannel: string;
    isDynamic: boolean;
    transformation?: BlockTransformationType;
    order: number;
}
export interface BlockTransformationType {
    name: string;
    html: string;
}

export interface BlockField {
    id: string;
    fieldId: string;
    label: string;
    desc: string;
    icon: string;
    value: any;
    type: string;
    title: string;
    bgColor: string;
    block: string;
    idx: number;
}

export interface DeleteBlockParams {
    id: string;
    salesChannel: string;
    parentPage: string;
}
export interface ProductType {
    id: string;
    SKUCode: string;
    productType: string;
    SKUName: string;
    shortName?: string;
    shortDescription: string;
    fullDescription: string;
    fullDescriptionBySalesChannel: string;
    flagBySalesChannel: string;
    unitOfMeasure: string;
    taxCode: string[];
    commodityCode: string;
    countryOriginISO: string;
    weight: number;
    nettWeight: number;
    weightMeasure: string;
    specifications?: {
        id: string;
        specificationLabel: string;
        specificationType: string;
        value: string;
        sort: number;
    }[];
    uniqueSellingPoints?: string;
    width: number;
    height: number;
    depth: number;
    imageUrl: string;
    imageFile?: any;
    dimensionMeasure: string;
    isShipped: boolean;
    isTracked: boolean;
    onHand: number;
    currentPrice: number;
    customsValue: number;
    costValue: number;
    bundle: any;
    schema: string;
    sellOnlyIfAvailable: boolean;
    reOrderAt: number;
    minOrderItems: number;
    maxOrderItems: number;
    listPrice?: number;
    accountingInfo: any;
    reviewInfo: any;
    reviews: any[];
    customInfo: any;
    isRollUp: boolean;
    product?: string;
    accreditations?: any[];
    productMetricHtml: string;
    reviewSKU?: string;
    availableShippingMethods:
        | Array<{
              shippingMethod: {
                  id: string;
                  name: string;
                  type: string;
                  userName: string;
                  password: string;
                  freeOver: string;
                  imageUrl: string;
                  minWeight: number;
                  maxWeight: number;
                  priority: number;
                  unitOfWeight: string;
                  shippingWeights: any;
                  createdOn: Date;
                  savedOn: Date;
                  createdBy: {
                      id: string;
                      type: string;
                      displayName: string;
                  };
              };
              priority: number;
          }>
        | { priority: number; id: string }[];
    createdOn: Date;
    savedOn: Date;
    createdBy: {
        id: string;
        type: string;
        displayName: string;
    };
    volumeDiscounts: Array<{
        id: string;
        amount: number;
        type: string;
        minQuantity: number;
    }>;
    assets: Array<{
        id: string;
        name: string;
        imageFile?: any;
        title: string;
        altTag: string;
        description: string;
        url: string;
        sort?: number;
        createdOn: Date;
        savedOn: Date;
        createdBy: {
            id: string;
            type: string;
            displayName: string;
        };
    }>;
    relatedProducts: Array<RelatedProductType>;
    url?: string;
    stock: {
        type: string;
        text: string;
        color: string;
    };
    sort?: number;
    productPricingMetrics?: {
        name: string;
        label: string;
        calculationHtml: string;
        product: string;
    }[];
    looseVolume?: number;
    numberOfItems?: number;
    offset?: number;
}

export interface ProductDataType {
    currentPrice: number;
    listPrice?: number;
    onHand?: number;
    stock: {
        type: string;
        text: string;
        color: string;
        fontColour: string;
        presaleDate?: string;
        presaleLimit?: string;
    };
    reviewSummary?: IProductReviewSummary;
}

export interface IProductReviewSummary {
    id: string;
    min: number;
    max: number;
    rating: number;
    count: number;
    reviewsUrl?: string;
}

export interface IProductReviewSummaryItem {
    count: number;
}

export interface ProductCategoryType {
    id: string;
    name: string;
    products: ProductType[];
    tags: TagCategoryTagType[];
    images?: AssetType[];
}

export interface PageImageType {
    src: string;
    title: string;
}

export interface PageListType {
    pages: PageType[];
}

export interface LinkItemType {
    src: string;
    text: string;
    target: string;
    class?: string;
}

export interface FieldType {
    id: string;
    fieldId: string;
    label: string;
    desc: string;
    icon: string;
    value: any;
    type: string;
    title: string;
    bgColor: string;
    block: string;
    idx: number;
    salesChannel: string;
    parentPage: string;
    data?: any;
    productCategory?: ProductCategoryType;
    imageFile?: any;
    slider?: {
        overlayText: string;
        images: {
            file: any;
            id: string;
            name: string;
        }[];
    };
    pageList?: {
        pages: {
            name: string;
            title: string;
            desc: string;
            imageUrl: {
                id: string;
                name: string;
                url: string;
                imageFile: any | undefined;
            };
        }[];
    };
}

export interface DeleteFieldParams {
    id: string;
    salesChannel: string;
    parentPage: string;
}

export interface PageType {
    id: string;
    name: string;
    slug: string;
    template: string;
    seo: {
        title: string;
        desc: string;
        imageUrl: string;
        keywords: string[];
    };
    redirectUrls: string[];
    title: string;
    desc: string;
    imageUrl: FileType;

    attributes: any[];
    content: BlockType[];
    co: Date;
    so: Date;
    salesChannel: string;
}

export interface FileType {
    id: string;
    name: string;
    url: string;
}
export enum OrderStatus {
    SHOPPING_CART = "shoppingCart",
    SECURE_PROCESSING = "secureProcessing",
    PAYMENT_AUTHORISED = "paymentAuthorised",
    PAYMENT_TAKEN = "paymentTaken",
    PROCESSING = "processing",
    IN_SHIP = "inShip",
    SHIPPED = "shipped",
    COMPLETED = "completed",
    CANCELLED = "cancelled",
    PAYMENT_FAILED = "paymentFailed"
}
export interface OrderType {
    PK: string;
    SK: string;
    id: string;
    invNumber?: string;
    number: string;
    orderDate: string;
    customer: CustomerType;
    status: string;
    paymentStatus: string;
    languageCode: string;
    currencyCode: string;
    isShipped: boolean;
    billingAddress: AddressType;
    shippingAddress: AddressType[];
    guest: boolean;
    subTotalAmount: number;
    subTotalTax: number;
    shippingAmount: number;
    shippingTaxAmount: number;
    paymentMethodAmount: number;
    totalWeight: number;
    paymentMethodAmountTax: number;
    discountAmount: number;
    discountTaxAmount: number;
    discountsApplied: IDiscount[];
    totalAmount: number;
    totalTax: number;
    dutyAmount: number;
    dutyAmountTax: number;
    itemsCount: number;
    shipmentsCount: number;
    orderNotes: string;
    orderItems: IOrderItem[];

    shipments: IOrderShipment[];
    shipmentsInvalid?: boolean;

    history?: IHistory[];
    metadata?: any;
    clientData?: IOrderClientData[];
    creditUsed: number;
    couponsUsed?: {
        couponCode: string;
    }[];
    gtagClientId?: string;
    errors?: string[];
    co: string;
    so: string;
}
export type OrderListType = {
    data?: OrderType[];
    nextToken?: string;
};
export interface IOrderClientData {
    type: string;
    action: string;
    data: string;
    parsed?: any;
}
export interface IOrderItem {
    id: string;
    unitAmount: number;
    parentId?: string;
    quantity: number;
    imageUrl: string;
    skuId: string;
    name: string;
    subTotalAmount: number;
    totalAmount: number;
    totalTaxAmount: number;
    schema?: string;
}

export interface IHistory {
    date: string;
    status: string;
    note: string;
}
export interface ICustomer {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    id: string;
}

export interface IAddress {
    id: string;
}
export interface IDiscount {
    PK: string;
    SK: string;
    id: string;
    name: string;
    amountApplied?: number;
    enabled?: boolean;
    validFrom: string;
    validTo: string;
    couponCode: string;
    type: string;
    applyTo: string;
    priority: number;
    applyFurtherDiscount: boolean;
    value: number;
    createdOn: string;
    savedOn: string;
}
export interface IShippingMethod {
    PK: string;
    SK: string;
    id: string;
    name: string;
    displayName?: string;
    freeOver?: number;
    imageUrl: string;
    minWeight: number;
    maxWeight: number;
    unitOfWeight: string;
    shippingWeights: IShippingWeight[];
    courier?: CourierType;
    shippingAmount?: number;
    shippingTaxAmount?: number;
    packageCount?: number;

    createdOn: string;
    savedOn: string;
    deliveryRange?: number;
}
export interface IShippingWeight {
    amount: number;
    upperLimit: number;
    id: string;
}

export interface CountryType {
    alpha2: string;
    alpha3: string;
    name: string;
    officialName: string;
    flagUrl: string;
    enabled: boolean;
    cb: string;
    sb: string;
    co: string;
    so: string;
}

export interface AssetType {
    id: string;
    name: string;
    title: string;
    altTag: string;
    description: string;
    url: string;
    imageFile?: IGatsbyImageDataParent;
    sort?: number;
}

export type IAvailableShippingMethod = {
    id: string;
    name?: string;
    displayName?: string;
    priority?: number;
    shippingAmount?: number;
    shippingTaxAmount?: number;
    shippingMethodSurcharge?: number;
    shippingMethodSurchargeTaxAmount?: number;
    shippingCost?: number;
    packageCount?: number;
    shippingZoneId?: string;
    estDispatchDate?: string;
    estDeliveryDates?: string[];
    zonePackage?: {
        shippingZone: string;
        shippingMethod: string;
        id: string;
        price: number;
        prices?: IShippingZonePackagePrice[];
        quantity: number;
        cost: number;
        package: {
            id: string;
            name: string;
            code: string;
        };
    };
    packages?: IProductShippingMethodPackage[];
    packageGroups?: IShipmentPackageGroup[];
    packageGroupsValid?: boolean;
    warehouse?: IWarehouse;
    shipmentId?: string;
    shippingMethod?: IShippingMethod;
    warehouseLocationStock?: IWarehouseStockLocation;
    collectionAddress?: IAddress;
};
export interface IProductShippingMethodPackage {
    id: string;
    name: string;
    priority: number;
    shippingMethod?: string;
}
export interface IShippingZonePackagePrice {
    shippingZoneId: string;
    shippingZonePackageId: string;
    salesChannelId: string;
    price: number;
}
export interface IShipmentPackageGroup {
    package: {
        id: string;
        name: string;
        code: string;
        minWeight: number;
        maxWeight: number;
    };
    packages: IShipmentPackage[];
}
export interface IShipmentPackage {
    weight: number;
    orderItems: IOrderItem[];
    imported?: boolean;
}
export interface IWarehouse {
    id: string;
    name: string;
    type: string;
    code: string;
    externalWarehouseGuid: string;
    addresses: [IAddress];
    locations: [IWarehouseLocation];
    availableCouriers: [ICourier];

    config: [IWarehouseConfig];
}
export interface IWarehouseConfig {
    propertyId: string;
    property: string;
    value: string;
}

export interface IWarehouseList {
    data: IWarehouse[];
    nextToken?: string;
}

export interface IWarehouseLocation {
    id: string;
    code: string;
    desc?: string;
}

export interface ICourier {
    id: string;
    name: string;
    type: string;
    config: ICourierConfig[];
    cutoffTime: string;
    serviceConfig: ICourierService[];
}
export interface ICourierService {
    id: string;
    type: string;
    displayName?: string;
    surchargeCode: string;
    surchargeAmount?: number;

    websiteEnabled?: boolean;
    customerServiceEnabled?: boolean;
    timedBooking?: boolean;
    times?: string;
    note?: string;
}
export interface ICourierConfig {
    propertyId: string;
    property: string;
    value: string;
}

export interface IWarehouseStockLocation {
    value: number;
    note?: string;
    product: {
        id: string;
        SKUCode: string;
        SKUName: string;
    };
    warehouse: Pick<IWarehouse, "id" | "name">;
    location: Pick<IWarehouseLocation, "id" | "code">;
}
export interface IOrderShipment {
    id: string;
    tenant: string;
    salesChannel: string;

    status?: string;
    isShipmentValid?: boolean;
    shipmentErrors: string[];
    shipmentNotes?: string;

    // cart fields
    customer: CustomerType;
    shippingMethod?: IShippingMethod;
    orderItems: IOrderItem[];
    availableShippingMethods: IAvailableShippingMethod[];

    // order fields
    orderId: string;
    orderReference: string;

    // tracking
    courierShipmentId?: string;
    trackingNumber?: string;
    trackingUrl?: string;
    shippingLabel?: string;
    estDeliveryDate: string;
    estDispatchDate: string;
    deliveryDate?: string;
    collectionDate?: string;

    collectionAddress?: AddressType;
    shippingAddress?: AddressType;

    dutyAmount?: number;
    dutyTaxAmount?: number;
    shippingAmount?: number;
    shippingTaxAmount?: number;
    otherCostAmounts?: number;
    totalWeight?: number;

    services?: IShipmentService[];

    cb?: string;
    sb?: string;
    co?: string;
    so?: string;
}

export interface IShipmentService {
    type: string;
    force?: boolean;
    surchargeCode: string;
    id: string;
    note: string;
}

export type EcommerceState = {
    order: any;
    loading: boolean;
    countries: any[];
};
export type AuthState = {
    user?: AppCognitoUser | null;
    customer: CustomerType | null;
};

export type AppCognitoUser = {
    username: string;
    email: string;
    given_name: string;
    family_name: string;
    phone_number: string;
    sub: string;
};
export interface CustomerType {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    cognitoUser: string;
    addresses: any;
    createdOn: Date;
    savedOn: Date;
    isGuest?: boolean;
    creditAmountTotal?: number;
    referralCode?: string;
    credits: {
        id: string;
        date: string;
        amount: number;
        description: string;
    }[];
}
export type SiteState = {
    ecommerce: EcommerceState;
    auth: AuthState;
    salesChannel: salesChannelState;
};
export type salesChannelState = {
    settings: Record<string, any> | null;
};
export interface CurrencyCodeType {
    id: string;
    name: string;
    currencyCode: string;
    formatString: string;
    roundTo: number;
    isBase: boolean;
    currentExchangeRate: string;
    previousExchangeRates: string;
    createdOn: Date;
    savedOn: Date;
    createdBy: {
        id: string;
        type: string;
        displayName: string;
    };
}

export interface ReviewType {
    id: string;
    title: string;
    author: string;
    body: string;
    ratingValue: string;
    datePublished: string;
    type: string;
    url: string;
    customerName: string;
    customer: string;
    order: string;
    product: string;
    externalRef: string;
    createdOn: Date;
    savedOn: Date;
    createdBy: {
        id: string;
        type: string;
        displayName: string;
    };
    salesChannel?: string;
}

export interface ContentType {
    id: string;
    modelId: string;
    data: any;
    imageFile: any | undefined;
    cb: string;
    sb: string;
    co: string;
    so: string;
}

export type ModelFieldType = {
    id: string;
    fieldId: string;
    type: string;
    label: string;
    renderer?: {
        input: string;
        output: string;
    };
};
export interface ModelType {
    id: string;
    name: string;
    modelId: string;
    description: string;
    fields?: ModelFieldType[];
    fieldsArr?: ModelFieldType[];
    transformations: {
        id: string;
        html: string;
        name: string;
    }[];
    cb: String;
    sb: String;
    co: String;
    so: String;
}

export interface IFaqProp {
    faqs: ContentType[];
    selectedTransformation: ModelType["transformations"][0];
}
export interface ITax {
    id: string;
    name: string;
    taxRates: ITaxRate[];
}
export interface ITaxRate {
    id: string;
    name: string;
    taxRate: number;
    countryCodeRegex?: string;
    notCountryCodeRegex?: string;
    stateCodeRegex?: string;
    notStateCodeRegex?: string;
    zipCodeRegex?: string;
    notZipCodeRegex?: string;
}
export interface ProductTaxCodeType {
    id: string;
    product: string;
    taxCode: string;
    name: string;
    taxRate: number;
    countryCodeRegex: string;
    notCountryCodeRegex: string;
    stateCodeRegex: string;
    notStateCodeRegex: string;
    zipCodeRegex: string;
    notZipCodeRegex: string;
}

export interface RelatedProductType {
    id: string;
    addedProduct: string;
    product: string;

    SKUCode: string;
    SKUName: string;
    shortDescription: string;
    imageUrl: string;
    currentPrice: number;
    url?: string;
    imageFile?: any;
}

export interface AddressType {
    id?: string;
    business?: boolean;
    firstName?: string;
    lastName?: string;
    company?: string;
    line1?: string;
    line2?: string;
    city?: string;
    postCode?: string;
    stateCode?: string;
    countryCode?: string;
    state?: string;
    lat?: string;
    long?: string;
    what3Words?: string;
    deliveryNotes?: string;
    type?: string;
    customer?: CustomerType;
}

export interface CourierType {
    id: string;
    name: string;
    type: string;
    config: { propertyId: string; property: string; value: string }[];
    imageUrl: string;
    unitOfMeasure: string;
    cutoffTime: string;
    hasBookInService: boolean;
    hasRestrictedAccessService: boolean;
    serviceConfig: {
        id: string;
        type: string;
        surchargeCode: string;
        websiteEnabled: boolean;
        customerServiceEnabled: boolean;
        note: string;
    }[];
}

export interface IFrameProps {
    data: {
        url: string;
        maxHeight: string | number;
        maxWidth: string | number;
    };
}

export interface IConfirmationDialog {
    show: boolean;
    onConfirm: () => Promise<void> | void;
    onCancel: () => Promise<void> | void;
}

export interface TagCategoryType {
    id: string;
    name: string;
    desc: string;
    salesChannel?: string;
    tags: TagCategoryTagType[];
}
export interface TagCategoryTagType {
    id: string;
    tag: string;
    name: string;
    tagCategory: string;
    salesChannel: string;
    icon: string;
    iconSelected: string;
    color: string;
    cb: string;
    sb: string;
    co: string;
    so: string;
}
